import React, { useCallback } from 'react';
import { Input, Item, NumberInput } from './EditableCell.style';
import { Checkbox } from 'react-inv-forms';

import Translation from '../../Translation';

const naturalNumberRegExp = new RegExp(/^[0-9]{1,5}/, 'i');
export interface Props {
  /** informacja, czy włączony jest tryb edycji rekordu */
  editing: boolean;
  /** kategoria danych (pozwalający określić, w jakiej kolumnie powinna znaleźć się dana) */
  dataIndex: string;
  /** tytuł */
  title: string;
  /** typ inputa */
  inputType: string;
  /** informacje o rekordzie, z którym powiązana jest dana */
  record: any;
  /** index danej */
  index: unknown;
  /** @ignore */
  children: React.ReactNode;
  /** dla typu checkbox - informacja, czy dana powinna być zaznaczona */
  checked?: boolean;
  /**  dla typu checkbox - callback wykonywany po zmianie na checkboxie */
  onChecked?: () => void;
  /** dla typu number - zakres wartości min i max */
  range?: { min: number; max: number };
  [key: string]: any;
}
/**
 * Komponent pomocniczy generujący odpowiedni typ edytowalnego inputa w tabelach
 *  - input tekstowy
 *  - input liczbowy
 *  - checkbox
 *  - input tekstowy nieedytowalny
 *  - percent - input liczbowy z wartościami 1-100
 *
 */
export const EditableCell: React.FunctionComponent<Props> = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  onChecked,
  checked,
  range,
  ...restProps
}: Props) => {
  const validateNumberInput = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    const max = Number(e.currentTarget.max);
    const min = Number(e.currentTarget.min);
    const value = Number(e.currentTarget.value);
    if (isNaN(value)) {
      e.currentTarget.value = e.currentTarget.min;
    } else if (!isNaN(value) && value > max) {
      e.currentTarget.value = e.currentTarget.max;
    } else if (!isNaN(value) && value < min) {
      e.currentTarget.value = e.currentTarget.min;
    }
  };
  const generateInputNode = useCallback((): React.ReactNode => {
    switch (inputType) {
      case 'number':
        return <NumberInput min={range ? range.min : 1} max={range ? range.max : 20} step={1} onKeyDown={validateNumberInput} />;
      case 'textInput':
        return <Input allowClear autoFocus />;
      case 'disabled':
        return <Input allowClear disabled={true} />;
      case 'checkbox':
        return <Checkbox checked={checked} onChange={onChecked} />;
      case 'percent':
        return <NumberInput min={0} max={100} step={1} onKeyDown={validateNumberInput} />;
      default:
        return <span></span>;
    }
  }, [inputType, range, checked, onChecked]);
  const inputNode = generateInputNode();
  return (
    <td {...restProps}>
      {editing ? (
        <>
          <Item
            valuePropName={inputType === 'checkbox' ? 'checked' : 'value'}
            name={dataIndex}
            rules={[
              {
                required: inputType !== 'checkbox',
                message: <Translation id='EMPTY_IS_NOT_ALLOWED' />,
              },
              {
                pattern: inputType === 'number' || inputType === 'percent' ? naturalNumberRegExp : undefined,
                message: <Translation id='NATURAL_NUMBERS_ALLOWED' />,
              },
            ]}
          >
            {inputNode}
          </Item>
        </>
      ) : (
        children
      )}
    </td>
  );
};
export default EditableCell;
